<template>
    <div class="bag">
        <button class="btn dlBtn" v-if="status==18||status==19" @click="download">下载司机端APP</button>
        <button class="btn edBtn" @click="coveralls">编辑个人工服信息</button>
        <div class="button" v-if="userInfo.company_phone">
            <p>如有疑问请联系当地分公司：<span>{{userInfo.company_phone}}</span></p>
            <p>（10:00-12:00，14:00-18:00）</p>
        </div>
    </div>
</template>
<script>
import{mapGetters} from 'vuex'
export default {
  props: {
    status: String
  },
  data () {
    return {
    }
  },
  methods: {
    download () {
      location.href = "../../../../../driver-app-pack/download-driver-app/index.html"
    },
    coveralls () {
      this.$router.push({name: 'editCoveralls'})
    }
  },
   computed: {
    ...mapGetters({
      userInfo:'getUserInfo'
    })
  }
}
</script>
<style lang="scss" scoped>
.button{
    font-size: .24rem;
    color: #19191A;
    padding: .1rem .3rem;
    text-align: center;
    p span{
        color: #2A2AFF;
    }
}
  .btn{
    height: .92rem;
    line-height: .92rem;
    width: 84%;
    border-radius: .06rem;
    font-size: .32rem;
    vertical-align: bottom;
    margin: .6rem 0 0 8%;
    padding: 0;
    box-sizing: border-box;
  }
  .dlBtn{
    color: #FFFFFF;
    background-image: linear-gradient(-269deg, #F25050 0%, #C93131 100%);
    border: none;
  }
 .edBtn{
      //  background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
        color: #19191A;
        border: 1px solid #42455B;
        background: #fff;
    }
    .bag{
      background: #fff;
      // padding: 0 .3rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/BottomLayout.vue